import { render, staticRenderFns } from "./UserDiv.vue?vue&type=template&id=8a754202&"
import script from "./UserDiv.vue?vue&type=script&lang=js&"
export * from "./UserDiv.vue?vue&type=script&lang=js&"
import style0 from "./UserDiv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports